import Table from "react-bootstrap/Table";
import PropTypes from 'prop-types';

//import React from 'react'

const TableFechas = ({dataVentas}) => {
  const {dataAOM,dataHANA, dataAOMDevolution}=dataVentas;
  console.log('dataAOMDevolution:...',dataAOMDevolution);
  const ventasAOM = dataAOM?.resultVentas || '';
  const ncAOM = dataAOM?.resultNC || '';
  const montoVentasAOM = dataAOM?.montoVentas || Number.NaN;
  const montoNCAOM = dataAOM?.montoNC || Number.NaN;
  const ventasHANA = dataHANA[0]?.VENTAS || '';
  const ncHANA = dataHANA[1]?.NC || '';
  //dataAOMDevolution.resultLastTrans.recordset[0].last_trans
  const lastTrans = dataAOMDevolution?.resultLastTrans?.recordset[0].last_trans || '';
  //dataAOMDevolution.resultNumTrans.recordset[0].num_trans
  const numTrans = dataAOMDevolution?.resultNumTrans?.recordset[0].num_trans || '';

  const  currencyFormatter= ({ currency, value}) =>{
    if(isNaN(value)) return null;
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      minimumFractionDigits: 2,
      currency
    }) 
    return formatter.format(value)
  }

  const formatterMiles = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
  
  const formattedNumberMiles = (number)=>{
  return formatterMiles.format(number).replace('$', '');
  }

  return (
    <Table striped bordered hover responsive>
      <thead>
        <tr>
          <th>Total Ventas Aptos</th>
          <th>Total Notas Credito Aptos</th>
          <th>Monto Ventas Aptos</th>
          <th>Monto Notas Credito Aptos</th>
          <th>Total Ventas SAP</th>
          <th>Total Notas Credito SAP</th>
          <th>Devoluciones Empresariales</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{formattedNumberMiles(ventasAOM)}</td>
          <td>{formattedNumberMiles(ncAOM)}</td>
          <td>{currencyFormatter({currency:"USD", value: montoVentasAOM})}</td>
          <td>{currencyFormatter({currency:"USD", value: montoNCAOM})}</td>
          <td>{formattedNumberMiles(ventasHANA)}</td>
          <td>{formattedNumberMiles(ncHANA)}</td>
          <td >
            <div className="d-flex flex-column">
            <div className="fs-6">{formattedNumberMiles(numTrans)}</div>
            <div className="small">{lastTrans.replace('T',' ').replace('Z','')}</div>
            </div>
          </td>
        </tr>
      </tbody>
    </Table>
  );
};

TableFechas.propTypes = {
  dataVentas: PropTypes.shape({
    dataAOM: PropTypes.object.isRequired,
    dataHANA: PropTypes.array.isRequired,
  }).isRequired,
};

export default TableFechas;
